// Maintenance gate — when site_settings.maintenance_enabled is on, blocks
// the entire app for non-admin users with a friendly interstitial. Admins
// see the regular site (so they can disable it). Loading state passes through
// to avoid a flash of the maintenance page on first paint.
import { Wrench, Loader2 } from "lucide-react";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { useUserRole } from "@/hooks/useUserRole";

interface Props {
  children: React.ReactNode;
}

const MaintenanceGate = ({ children }: Props) => {
  const { settings, loading } = useSiteSettings();
  const { isAdmin, loading: roleLoading } = useUserRole();

  if (loading || roleLoading) return <>{children}</>;
  if (!settings.maintenance_enabled || isAdmin) return <>{children}</>;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-5">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 border border-primary/30">
          <Wrench className="w-8 h-8 text-primary" />
        </div>
        <div className="space-y-2">
          <h1 className="font-mono font-extrabold text-2xl text-foreground">
            Brief maintenance
          </h1>
          <p className="text-sm text-muted-foreground whitespace-pre-line">
            {settings.maintenance_message}
          </p>
        </div>
        <div className="inline-flex items-center gap-2 text-[11px] font-mono text-muted-foreground">
          <Loader2 className="w-3 h-3 animate-spin" />
          We'll be back shortly. Refresh in a few minutes.
        </div>
      </div>
    </div>
  );
};

export default MaintenanceGate;
